(() => {
  const bridgeKey = '__easifySavorBridge';

  window[bridgeKey]?.destroy?.();

  let animationFrame;

  const isVisible = (element) =>
    Boolean(
      element &&
      (
        element.offsetWidth ||
        element.offsetHeight ||
        element.getClientRects().length
      )
    );

  const isTransparent = (color) =>
    !color ||
    color === 'transparent' ||
    color === 'rgba(0, 0, 0, 0)';

  const findNativeGroup = (button) =>
    button?.closest('.variant-option');

  const applyThemeStyles = () => {
    const nativeButtons = [
      ...document.querySelectorAll(
        '.variant-option__button-label'
      ),
    ].filter(isVisible);

    const normalButton =
      nativeButtons.find(
        (button) =>
          !button.querySelector('input:checked')
      ) || nativeButtons[0];

    const selectedButton =
      nativeButtons.find(
        (button) =>
          button.querySelector('input:checked')
      ) || nativeButtons[0];

    if (!normalButton || !selectedButton) return;

    const normalStyle =
      getComputedStyle(normalButton);

    const selectedStyle =
      getComputedStyle(selectedButton);

    const textElement =
      normalButton.querySelector(
        '.variant-option__button-label__text'
      ) || normalButton;

    const textStyle =
      getComputedStyle(textElement);

    const selectedPill =
      selectedButton.querySelector(
        '.variant-option__button-label__pill'
      );

    const pillStyle = selectedPill
      ? getComputedStyle(selectedPill)
      : null;

    const selectedBackground =
      !isTransparent(pillStyle?.backgroundColor)
        ? pillStyle.backgroundColor
        : selectedStyle.backgroundColor;

    const nativeGroup =
      findNativeGroup(normalButton);

    const nativeGroupStyle = nativeGroup
      ? getComputedStyle(nativeGroup)
      : null;

    const gap =
      nativeGroupStyle?.columnGap &&
      nativeGroupStyle.columnGap !== 'normal'
        ? nativeGroupStyle.columnGap
        : nativeGroupStyle?.gap || '12px';

    document
      .querySelectorAll(
        'product-form-component ' +
        '.easify.portal ' +
        '.po-radioButtons-radioGroup'
      )
      .forEach((group) => {
        const values = {
          '--es-gap': gap,

          '--es-min-height':
            normalStyle.minHeight,

          '--es-padding-top':
            normalStyle.paddingTop,

          '--es-padding-right':
            normalStyle.paddingRight,

          '--es-padding-bottom':
            normalStyle.paddingBottom,

          '--es-padding-left':
            normalStyle.paddingLeft,

          '--es-background':
            normalStyle.backgroundColor,

          '--es-color':
            normalStyle.color,

          '--es-border-width':
            normalStyle.borderTopWidth,

          '--es-border-style':
            normalStyle.borderTopStyle,

          '--es-border-color':
            normalStyle.borderTopColor,

          '--es-border-radius':
            normalStyle.borderRadius,

          '--es-selected-background':
            selectedBackground,

          '--es-selected-color':
            selectedStyle.color,

          '--es-selected-border-color':
            selectedStyle.borderTopColor,

          '--es-font-family':
            textStyle.fontFamily,

          '--es-font-size':
            textStyle.fontSize,

          '--es-font-weight':
            textStyle.fontWeight,

          '--es-font-style':
            textStyle.fontStyle,

          '--es-line-height':
            textStyle.lineHeight,

          '--es-letter-spacing':
            textStyle.letterSpacing,

          '--es-text-transform':
            textStyle.textTransform,
        };

        Object.entries(values).forEach(
          ([property, value]) => {
            group.style.setProperty(
              property,
              value
            );
          }
        );
      });
  };

  const scheduleUpdate = () => {
    cancelAnimationFrame(animationFrame);

    animationFrame =
      requestAnimationFrame(applyThemeStyles);
  };

  const observer = new MutationObserver(
    scheduleUpdate
  );

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true,
  });

  window.addEventListener(
    'resize',
    scheduleUpdate,
    { passive: true }
  );

  document.addEventListener(
    'shopify:section:load',
    scheduleUpdate
  );

  scheduleUpdate();

  window[bridgeKey] = {
    destroy() {
      observer.disconnect();

      cancelAnimationFrame(animationFrame);

      window.removeEventListener(
        'resize',
        scheduleUpdate
      );

      document.removeEventListener(
        'shopify:section:load',
        scheduleUpdate
      );
    },
  };
})();